<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal-view p-3 m-3">
        <div class="d-flex justify-content-end">
          <img
            src="@/assets/icon/close.png"
            alt="close"
            class="cursor-pointer"
            @click="closeModal"
          >
        </div>
        <div
          v-if="loadingList"
          class="content px-3 text-center"
        >
          <div class="spinner-border spinner-border-sm">
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </div>
        <div
          v-if="!loadingList"
          class="content px-3"
        >
          <div
            v-if="role === 'Administrator'"
            class="cursor-pointer border-bottom d-flex justify-content-between py-3"
            @click="changeAction('employee')"
          >
            <h5 class="font-weight-bold">
              {{ $t("modal.view-assessment.employee") }}
            </h5>
            <div>
              <img
                v-if="!show.employee"
                src="@/assets/icon/add.png"
                alt=""
              >
              <img
                v-if="show.employee"
                src="@/assets/icon/min.png"
                alt=""
              >
            </div>
          </div>
          <div
            v-if="show.employee"
            class="border-bottom pb-2"
          >
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.employee-information.nik") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ responseSurvey.data.user.nric || "N/A" }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{
                    $t("modal.view-assessment.employee-information.fullname")
                  }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ responseSurvey.data.user.fullname || "N/A" }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.employee-information.age") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ age || "-" }}/{{
                    responseSurvey.data.user.birthdate || "-"
                  }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.employee-information.gender") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{
                    responseSurvey.data.user.gender === null
                      ? "N/A"
                      : responseSurvey.data.user.gender
                        ? $t("table-assessment.gender.male")
                        : $t("table-assessment.gender.female")
                  }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{
                    $t("modal.view-assessment.employee-information.position")
                  }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ responseSurvey.data.user.position || "N/A" }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{
                    $t(
                      "modal.view-assessment.employee-information.work-location"
                    )
                  }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{
                    responseSurvey.data.user.workLocation
                      ? responseSurvey.data.user.workLocation.name
                      : "N/A"
                  }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{
                    $t("modal.view-assessment.employee-information.department")
                  }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ responseSurvey.data.user.workUnit || "N/A" }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{
                    $t(
                      "modal.view-assessment.employee-information.company-name"
                    )
                  }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{
                    responseSurvey.data.user.company
                      ? responseSurvey.data.user.company.name
                      : "N/A"
                  }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.employee-information.email") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ responseSurvey.data.user.email || "N/A" }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.employee-information.phone") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ responseSurvey.data.user.phoneNumber || "N/A" }}
                </small>
              </div>
            </div>
          </div>
          <div
            class="cursor-pointer border-bottom d-flex justify-content-between py-3"
            @click="changeAction('general')"
          >
            <h5 class="font-weight-bold">
              {{ $t("modal.view-assessment.general") }}
            </h5>
            <div>
              <img
                v-if="!show.general"
                src="@/assets/icon/add.png"
                alt=""
              >
              <img
                v-if="show.general"
                src="@/assets/icon/min.png"
                alt=""
              >
            </div>
          </div>
          <div
            v-if="show.general"
            class="border-bottom pb-2"
          >
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.general-information.send") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{ sendDate || "N/A" }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{
                    $t(
                      "modal.view-assessment.general-information.work-location"
                    )
                  }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{
                    responseSurvey.data.workLocation
                      ? responseSurvey.data.workLocation.name
                      : "N/A"
                  }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.general-information.comorbid") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small>
                  {{
                    responseSurvey.data.user.comorbid === null
                      ? "N/A"
                      : responseSurvey.data.user.comorbid
                        ? $t("user-profile.comorbid.true")
                        : $t("user-profile.comorbid.false")
                  }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{ $t("modal.view-assessment.general-information.risk") }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div
                class="col-md-7 col-lg-8 d-none d-sm-block p-0 text-capitalize"
              >
                <small v-if="$i18n.locale === 'en'">
                  {{ responseSurvey.data.riskEng || "N/A" }}
                </small>
                <small v-else-if="$i18n.locale === 'id'">
                  {{ responseSurvey.data.riskIdn || "N/A" }}
                </small>
              </div>
            </div>
            <div class="row m-0 my-2">
              <div class="col-md-4 col-lg-3 p-0">
                <small class="font-weight-bold">
                  {{
                    $t(
                      "modal.view-assessment.general-information.recommendation"
                    )
                  }}
                </small>
              </div>
              <div class="col-md-1 col-lg-1 d-none d-sm-block p-0">
                <small class="font-weight-bold">
                  :
                </small>
              </div>
              <div class="col-md-7 col-lg-8 d-none d-sm-block p-0">
                <small v-if="$i18n.locale === 'en'">
                  <div
                    v-for="(recommendation, r) of responseSurvey.data
                      .recommendationEng"
                    :key="r"
                  >
                    {{ recommendation }}
                  </div>
                  <div v-if="!responseSurvey.data.recommendationEng.length">
                    N/A
                  </div>
                </small>
                <small v-if="$i18n.locale === 'id'">
                  <div
                    v-for="(recommendation, r) of responseSurvey.data
                      .recommendationIdn"
                    :key="r"
                  >
                    {{ recommendation }}
                  </div>
                  <div v-if="!responseSurvey.data.recommendationIdn.length">
                    N/A
                  </div>
                </small>
              </div>
            </div>
          </div>
          <div
            class="cursor-pointer border-bottom d-flex justify-content-between py-3"
            @click="changeAction('assessment')"
          >
            <h5 class="font-weight-bold">
              {{ $t("modal.view-assessment.assessment") }}
            </h5>
            <div>
              <img
                v-if="!show.assessment"
                src="@/assets/icon/add.png"
                alt=""
              >
              <img
                v-if="show.assessment"
                src="@/assets/icon/min.png"
                alt=""
              >
            </div>
          </div>
          <div v-if="show.assessment">
            <div
              v-for="(question, i) in listQuestionAssessment"
              :key="i"
              class="mt-4"
            >
              <p class="question">
                <strong v-if="$i18n.locale === 'en'">{{
                  question.titleEng
                }}</strong>
                <strong v-if="$i18n.locale === 'id'">{{
                  question.titleIdn
                }}</strong>
              </p>

              <!-- PARENT ANSWERS -->
              <textarea
                v-if="question.type === 'textbox'"
                :ref="question.id"
                v-model="resultQuestionAssessment[i].value"
                class="form-control ml-3 col-11"
                rows="4"
                disabled
              />
              <div
                v-for="(questionAnswer, j) in question.questionAnswers"
                :key="j"
              >
                <input
                  v-if="question.type === 'radio_button'"
                  v-model="resultQuestionAssessment[i].value"
                  type="radio"
                  class="input-question"
                  :value="questionAnswer.id"
                  disabled
                >
                <input
                  v-if="question.type === 'checkbox'"
                  v-model="resultQuestionAssessment[i].value"
                  type="checkbox"
                  class="input-question"
                  :value="questionAnswer.id"
                  disabled
                >
                <label
                  :for="questionAnswer.titleEng"
                  class="label-question"
                >
                  <span v-if="$i18n.locale === 'en'">{{
                    questionAnswer.titleEng
                  }}</span>
                  <span v-if="$i18n.locale === 'id'">{{
                    questionAnswer.titleIdn
                  }}</span>
                </label>
              </div>
            </div>
          </div>
          <template v-if="isRecommendationNull">
            <div
              class="cursor-pointer border-bottom d-flex justify-content-between py-3"
              @click="changeAction('recommendation')"
            >
              <h5 class="font-weight-bold">
                {{ $t("modal.view-assessment.recommendation") }}
              </h5>
              <div>
                <img
                  v-if="!show.assessment"
                  src="@/assets/icon/add.png"
                  alt=""
                >
                <img
                  v-if="show.assessment"
                  src="@/assets/icon/min.png"
                  alt=""
                >
              </div>
            </div>
            <div v-if="show.recommendation">
              <div
                v-if="responseSurvey.data.status === 'IN PROGRESS'"
                class="text-center d-flex justify-content-center mt-4 mb-2"
              >
                <div class="bg-progress">
                  <small class="font-weight-bold">
                    {{ $t('modal-recommendation.status-observation.in') }}
                  </small>
                </div>
              </div>
              <div
                v-if="responseSurvey.data.status === 'CLOSED'"
                class="text-center d-flex justify-content-center mt-4 mb-2"
              >
                <div class="bg-finished bg-danger text-white">
                  <small class="font-weight-bold">
                    {{ $t('modal-recommendation.status-observation.finish') }}
                  </small>
                </div>
              </div>
              <div class="mt-2 d-flex justify-content-center">
                <small class="font-weight-bold font-italic">
                  {{ $t('modal.view-assessment.recommendation-information.last') }}:
                  {{ responseSurvey.data.children[0].updatedBy || '---' }} at
                  {{ formatDate(responseSurvey.data.children[0].updatedAt) }}
                </small>
              </div>
              <div
                v-for="(question, i) in listQuestionRecommendation"
                :key="i"
                class="mt-2"
              >
                <p class="question">
                  <strong v-if="$i18n.locale === 'en'">{{
                    question.titleEng
                  }}</strong>
                  <strong v-if="$i18n.locale === 'id'">{{
                    question.titleIdn
                  }}</strong>
                </p>

                <!-- PARENT ANSWERS -->
                <textarea
                  v-if="question.type === 'textbox'"
                  :ref="question.id"
                  v-model="resultQuestionRecommendation[i].value"
                  class="form-control ml-3 col-11"
                  rows="4"
                  disabled
                />
                <div
                  v-for="(questionAnswer, j) in question.questionAnswers"
                  :key="j"
                >
                  <input
                    v-if="question.type === 'radio_button'"
                    v-model="resultQuestionRecommendation[i].value"
                    type="radio"
                    class="input-question"
                    :value="questionAnswer.id"
                    disabled
                  >
                  <input
                    v-if="question.type === 'checkbox'"
                    v-model="resultQuestionRecommendation[i].value"
                    type="checkbox"
                    class="input-question"
                    :value="questionAnswer.id"
                    disabled
                  >
                  <label
                    :for="questionAnswer.titleEng"
                    class="label-question"
                  >
                    <span v-if="$i18n.locale === 'en'">{{
                      questionAnswer.titleEng
                    }}</span>
                    <span v-if="$i18n.locale === 'id'">{{
                      questionAnswer.titleIdn
                    }}</span>
                  </label>
                </div>
                <input
                  v-if="showOther.isOpen && i === 3"
                  v-model="showOther.value"
                  type="text"
                  class="form-control form-control-sm ml-3 col-11"
                  disabled
                >
              </div>
            </div>
          </template>
        </div>
        <div class="text-center d-flex justify-content-center mt-3">
          <div
            v-if="todayDate === createDate && role === 'Employee'"
            class="col-10 col-md-5 col-lg-3 col-xl-2 p-0 py-2 btn-info rounded"
            @click="nextScreen"
          >
            Update
          </div>
          <div
            v-if="role === 'Administrator'"
            class="col-10 col-md-5 col-lg-3 col-xl-2 p-0 py-2 btn-info rounded"
            @click="nextScreen"
          >
            Update
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Api from '@/utils/Api'
import { format, differenceInYears } from 'date-fns'
import { SURVEY_ID, RECOMMENDATION_ID } from '@/fixtures'

const TYPE_INITIAL_VALUES = {
  radio_button: '',
  checkbox: []
}

export default {
  name: 'ModalSuccess',

  props: {
    idAssessment: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      responseSurvey: {},
      show: {
        employee: false,
        general: false,
        assessment: false,
        recommendation: false
      },
      sendDate: '',
      createDate: '',
      todayDate: '',
      role: '',
      listQuestionAssessment: null,
      listQuestionRecommendation: null,
      loadingList: false,
      resultQuestionAssessment: [],
      resultQuestionRecommendation: [],
      age: '',
      showOther: {
        isOpen: false,
        value: ''
      },
      isRecommendationNull: false
    }
  },

  async mounted () {
    this.loadingList = true
    await this.getResponseAssessment(this.idAssessment)
    await this.getQuestion(SURVEY_ID, 'assessment', 'listQuestionAssessment')
    await this.getQuestion(RECOMMENDATION_ID, 'recommendation', 'listQuestionRecommendation')
    this.loadingList = false
  },

  methods: {
    closeModal () {
      this.$emit('openModal', 'successAssessment', false)
    },
    async getResponseAssessment (id) {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      this.role = dataLoc.role.name
      const data = await Api.surveys.getResponsesId(SURVEY_ID, id)
      this.responseSurvey = data
      this.isRecommendationNull = this.responseSurvey.data.children[0] !== undefined
      if (this.responseSurvey.data.user.birthdate) {
        this.age = differenceInYears(
          new Date(),
          new Date(this.responseSurvey.data.user.birthdate)
        )
        this.responseSurvey.data.user.birthdate = format(
          new Date(this.responseSurvey.data.user.birthdate),
          'dd-MMM-yyyy'
        )
      }
      this.sendDate = format(
        new Date(this.responseSurvey.data.createdAt),
        'dd-MMM-yyyy hh:mm'
      )
      this.createDate = format(
        new Date(this.responseSurvey.data.createdAt),
        'dd-MM-yyyy'
      )
      this.todayDate = format(new Date(), 'dd-MM-yyyy')
    },
    changeAction (headerName) {
      this.show[headerName] = !this.show[headerName]
    },
    async getQuestion (id, type, variableList) {
      const { data } = await Api.surveys.get(id)
      this[variableList] = data.questions
      switch (type) {
        case 'assessment':
          this.initialModelAssessment()
          break
        case 'recommendation':
          this.initialModelRecommendation()
          break
      }
    },
    initialModelAssessment () {
      this.resultQuestionAssessment = this.listQuestionAssessment.map(({ id, type }) => ({
        id,
        value: TYPE_INITIAL_VALUES[type],
        openChildren: false,
        type: type,
        isMapping: false
      }))
      for (let i = 0; i < this.responseSurvey.data.assessmentResponseAnswers.length; i++) {
        const index = this.resultQuestionAssessment.findIndex(element => {
          return this.responseSurvey.data.assessmentResponseAnswers[i] ? element.id === this.responseSurvey.data.assessmentResponseAnswers[i].questionId : ''
        })
        if (index !== -1) {
          if (this.resultQuestionAssessment[index].type === 'radio_button') {
            this.resultQuestionAssessment[index].isMapping = true
            this.resultQuestionAssessment[index].value = this.responseSurvey.data.assessmentResponseAnswers[i].answers[0] ? this.responseSurvey.data.assessmentResponseAnswers[i].answers[0].id : ''
          }
          if (this.resultQuestionAssessment[index].type === 'checkbox') {
            this.resultQuestionAssessment[index].isMapping = true
            if (this.resultQuestionAssessment[index].value.length) {
              this.resultQuestionAssessment[index].value = []
            }
            for (let j = 0; j < this.responseSurvey.data.assessmentResponseAnswers[i].answers.length; j++) {
              this.resultQuestionAssessment[index].value[j] = this.responseSurvey.data.assessmentResponseAnswers[i].answers[j] ? this.responseSurvey.data.assessmentResponseAnswers[i].answers[j].id : ''
            }
          }
          if (this.resultQuestionAssessment[index].type === 'textbox') {
            this.resultQuestionAssessment[index].isMapping = true
            this.resultQuestionAssessment[index].value = this.responseSurvey.data.assessmentResponseAnswers[i] ? this.responseSurvey.data.assessmentResponseAnswers[i].value : ''
          }
        }
      }
      this.resultQuestionAssessment.forEach(element => {
        if (!element.isMapping && element.type === 'checkbox') {
          element.value = []
        }
        if (!element.isMapping && element.type === 'radio_button') {
          element.value = ''
        }
      })
      this.checkExistingAnswer()
    },
    checkExistingAnswer () {
      this.resultQuestionAssessment.forEach(element => {
        if (element.type === 'checkbox') {
          const question = this.listQuestionAssessment.filter(elementList => elementList.id === element.id)
          const valTemp = element.value.map(val => val)
          valTemp.forEach(val => {
            const existing = question[0].questionAnswers.findIndex(question => question.id === val)
            if (existing === -1) {
              const index = element.value.findIndex(elementVal => elementVal === val)
              element.value.splice(index, 1)
            }
          })
        }
      })
    },
    initialModelRecommendation () {
      this.resultQuestionRecommendation = this.listQuestionRecommendation.map(({ id, type }) => ({
        id,
        value: TYPE_INITIAL_VALUES[type],
        openChildren: false,
        type: type
      }))
      for (let i = 0; i < this.resultQuestionRecommendation.length; i++) {
        if (this.resultQuestionRecommendation[i].type === 'radio_button' && this.responseSurvey.data.children[0]) {
          this.resultQuestionRecommendation[i].value = this.responseSurvey.data.children[0].assessmentResponseAnswers[i].answers[0] ? this.responseSurvey.data.children[0].assessmentResponseAnswers[i].answers[0].id : ''
          this.checkValue(i)
          if (this.showOther.isOpen && i === 3) {
            this.showOther.value = this.responseSurvey.data.children[0].assessmentResponseAnswers[i].value
          }
        } else if (this.resultQuestionRecommendation[i].type === 'checkbox' && this.responseSurvey.data.children[0]) {
          if (this.resultQuestionRecommendation[i].value.length) {
            this.resultQuestionRecommendation[i].value = []
          }
          for (let j = 0; j < this.responseSurvey.data.children[0].assessmentResponseAnswers[i].answers.length; j++) {
            this.resultQuestionRecommendation[i].value[j] = this.responseSurvey.data.children[0].assessmentResponseAnswers[i].answers[j] ? this.responseSurvey.data.children[0].assessmentResponseAnswers[i].answers[j].id : ''
          }
        } else if (this.resultQuestionRecommendation[i].type === 'textbox' && this.responseSurvey.data.children[0]) {
          this.resultQuestionRecommendation[i].value = this.responseSurvey.data.children[0].assessmentResponseAnswers[i].value
        }
      }
    },
    checkValue (index) {
      if (index === 3) {
        this.showOther.isOpen = this.resultQuestionRecommendation[index].value === '948085a8-cb34-4fad-88fd-f748065e6cf1'
      }
    },
    nextScreen () {
      this.$router.push({
        name: 'instruction',
        params: {
          idAssessment: this.idAssessment,
          edit: true
        }
      })
    },
    formatDate (date) {
      return format(new Date(date), 'dd MMM yyyy (H:mm)')
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  background-color: rgba(128, 128, 128, 0.527) !important;
  display: flex;
  opacity: 1 !important;
  justify-content: center;
  align-items: center;
}
.modal-view {
  background: white !important;
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
  height: 95vh;
  width: 60vw;
  border-radius: 9.9px;
}
.cursor-pointer {
  cursor: pointer;
}
.content {
  height: 600px;
  overflow: auto;
}
.question {
  color: #121212;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.input-question {
  margin-right: 10px;
}
.label-question {
  font-size: 12px;
  vertical-align: middle;
  font-weight: 500;
  padding-top: 5px;
}
textarea {
  resize: none;
  font-size: 12px;
}
.bg-progress {
  background-color: #F6D214;
  border-radius: 30px;
  width: 130px;
}
.bg-finished {
  border-radius: 30px;
  width: 170px;
}
</style>
